import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchSectionConfiguration } from "../api/sectionConfigurationService";
import { getDefaultSectionConfiguration, parseSectionConfiguration } from "../utils/sectionConfiguration";

function getFacilityId() {
  const v = sessionStorage.getItem("facility_name");
  return v && v !== "null" && v !== "undefined" ? v : null;
}

let cachedConfig = null;
let inflightRequest = null;

function loadSectionConfiguration() {
  if (cachedConfig) {
    return Promise.resolve(cachedConfig);
  }
  if (inflightRequest) {
    return inflightRequest;
  }

  const facilityId = getFacilityId();
  if (!facilityId) {
    toast.error("Facility not found. Please log in again.");
    cachedConfig = getDefaultSectionConfiguration();
    return Promise.resolve(cachedConfig);
  }

  inflightRequest = fetchSectionConfiguration(facilityId)
    .then((raw) => {
      cachedConfig = parseSectionConfiguration(raw);
      return cachedConfig;
    })
    .catch(() => {
      console.warn("Using default form layout — section configuration could not be loaded.");
      cachedConfig = getDefaultSectionConfiguration();
      return cachedConfig;
    })
    .finally(() => {
      inflightRequest = null;
    });

  return inflightRequest;
}

export function useSectionConfiguration() {
  const [config, setConfig] = useState(() => cachedConfig || getDefaultSectionConfiguration());
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    loadSectionConfiguration().then((nextConfig) => {
      if (!cancelled && nextConfig) {
        setConfig(nextConfig);
      }
    });

    return () => { cancelled = true; };
  }, []);

  return { config, loading: false, error, ready: true };
}
